// src/pages/MorePage.tsx
import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  List,
  ListItem,
} from 'framework7-react';

import AccountInfoIcon from '@assets/icons/account-info.svg?react';
import RefreshIcon from '@assets/icons/Refresh.svg?react';
import HelpIcon from '@assets/icons/help.svg?react';
import SignOutIcon from '@assets/icons/sign-out.svg?react';

import { handleLogout } from '../utils/logout';
import { BottomTabBar } from './BottomTabBar';
import '@styles/more.css';

function MorePage() {
  return (
    <Page name="more" className="page-content-flex">
      <Navbar className="no-outline">
        <NavLeft backLink="" />
        <NavTitle>More</NavTitle>
      </Navbar>

      <div className="main-content">
        <List mediaList className="more-list">
          <ListItem
            title="Account Info"
            subtitle="Update/edit your name, email or password"
            link="/account"
            className="more-list-item no-chevron"
          >
            <div slot="media" className="more-icon">
              <AccountInfoIcon />
            </div>
          </ListItem>

          <ListItem
            title="Subscription Plan"
            subtitle="Manage or cancel your plan"
            link="/subscription"
            className="more-list-item no-chevron"
          >
            <div slot="media" className="more-icon">
              <RefreshIcon />
            </div>
          </ListItem>

          <ListItem
            title="Get More Help"
            subtitle="Get in touch with support"
            onClick={() => {
              window.location.href = 'mailto:dealsaver@legalclosing.ca';
            }}
            className="more-list-item no-chevron"
          >
            <div slot="media" className="more-icon">
              <HelpIcon />
            </div>
          </ListItem>
        </List>
      </div>

      <div className="signout-wrapper">
        <List inset className="signout-list">
          <ListItem
            onClick={handleLogout}
            className="signout-item"
            title="Sign out of DealSaver"
          >
            <div slot="media" className="signout-icon">
              <SignOutIcon />
            </div>
          </ListItem>
        </List>
      </div>


      <BottomTabBar />
    </Page>
  );
}

export default MorePage;
